/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('StudentController', StudentController);

    StudentController.$inject = ['DateUtils', '$scope', 'DataUtils', '$translate', 'AlertService', '$http'];

    function StudentController (DateUtils, $scope, DataUtils, $translate, AlertService, $http) {

        var vm = this;

        vm.profile = null;
        vm.save = save;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.fileIsNew = false;
        vm.university = null;
        vm.oldUniversity = null;

        loadImmatriculation();

        function loadImmatriculation() {
            $http.get('api/member/immatriculation/', {}).then(function(response) {
                vm.profile = response.data;
                DateUtils.convertLocalDateFromServer(vm.profile.matriculationDate);
                var difference_ms = Math.abs(new Date() - DateUtils.convertLocalDateFromServer(vm.profile.matriculationDate));
                var ONE_DAY = 1000 * 60 * 60 * 24;
                vm.daysLeft = 365 - Math.floor(difference_ms / ONE_DAY);
                vm.university = !!vm.profile.university;
                vm.fileIsNew = false;
                vm.oldUniversity = vm.profile.university;
            });
        }


        function save () {
            vm.isSaving = true;
            if (!vm.university && !vm.profile.isStudent) {
                vm.profile.university = null;
            }
            $http.post('api/member/immatriculation/', vm.profile).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                vm.fileIsNew = false;
                loadImmatriculation();
                AlertService.success($translate.instant('global.messages.update.alert'));
            }, function(error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.fileIsNew = true;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };
    }
})();
